import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NewsEngComponent } from './news-eng.component';

const routes: Routes = [
  {
    path: '',
    component: NewsEngComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./../view/home/home.module').then(d => d.HomeModule)
      },
      {
        path: 'about-us',
        loadChildren: () => import('./../view/about-us/about-us.module').then(d => d.AboutUsModule)
      },
      {
        path: 'live',
        loadChildren: () => import('./../view/live/live.module').then(d => d.LiveModule)
      },
      {
        path: 'programs',
        loadChildren: () => import('./../view/program/program.module').then(d => d.ProgramModule)
      },
      {
        path: 'author',
        loadChildren: () => import('./../view/author/author.module').then(d => d.AuthorModule)
      },
      {
        path: 'author/:author',
        loadChildren: () => import('./../view/author/author.module').then(d => d.AuthorModule)
      },
      {
        path: ':year/:month/:day/:name',
        loadChildren: () => import('../view/news/news.module').then(m => m.NewsModule),
      },

      {
        path: 'home',
        loadChildren: () => import('../view/home/home.module').then(m => m.HomeModule),

      },
      {
        path: 'latest',
        loadChildren: () => import('../view/latest/latest.module').then(m => m.LatestModule),

      },
      {
        path: 'latest-news',
        loadChildren: () => import('../view/latest/latest.module').then(m => m.LatestModule),

      },
      {
        path: 'featured',
        loadChildren: () => import('../view/featured/featured.module').then(m => m.FeaturedModule),

      },
      {
        path: 'local',
        loadChildren: () => import('../view/local/local.module').then(m => m.LocalModule),

      },
      {
        path: 'sports',
        loadChildren: () => import('../view/sport/sport.module').then(m => m.SportModule),

      },
      {
        path: 'business',
        loadChildren: () => import('../view/business/business.module').then(m => m.BusinessModule),

      },
      {
        path: 'world',
        loadChildren: () => import('../view/world/world.module').then(m => m.WorldModule),

      },

      {
        path: 'category/featured',
        loadChildren: () => import('../view/featured/featured.module').then(m => m.FeaturedModule),

      },
      {
        path: 'category/local',
        loadChildren: () => import('../view/local/local.module').then(m => m.LocalModule),

      },
      {
        path: 'category/sports',
        loadChildren: () => import('../view/sport/sport.module').then(m => m.SportModule),

      },
      {
        path: 'category/business',
        loadChildren: () => import('../view/business/business.module').then(m => m.BusinessModule),

      },
      {
        path: 'category/world',
        loadChildren: () => import('../view/world/world.module').then(m => m.WorldModule),

      },
      {
        path: 'tag/:tag',
        loadChildren: () => import('../view/tags/tags.module').then(m => m.TagsModule),
      },
      {
        path: 'tag',
        loadChildren: () => import('../view/tags/tags.module').then(m => m.TagsModule),
      },
      {
        path: 'news/:id',
        loadChildren: () => import('../view/news/news.module').then(m => m.NewsModule),

      },
      {
        path: 'search',
        loadChildren: () => import('../view/search/search.module').then(m => m.SearchModule),

      },
      {
        path: ':year/:month/:day',
        loadChildren: () => import('../view/timeline/timeline.module').then(m => m.TimelineModule),

      },
      {
        path: ':year/:month',
        loadChildren: () => import('../view/timeline/timeline.module').then(m => m.TimelineModule),

      },
      {
        path: ':year',
        loadChildren: () => import('../view/timeline/timeline.module').then(m => m.TimelineModule),

      },
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewsEngRoutingModule { }
